var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 11.22 7.5)",
    id: "rozVhyF3KVnB9Ob0Wf1qE"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(107,70,236)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-11.22, -7.5)",
    d: "M 3.06065 2.26973 L 0.71875 4.53951 L 3.07225 6.82015 L 5.42575 9.10079 L 5.92328 8.62031 L 6.42077 8.13987 L 4.91818 6.68278 L 3.41558 5.22573 L 10.1109 5.23834 L 16.8063 5.2509 L 17.1529 5.3548 C 18.4246 5.73584 19.441 6.57906 19.9564 7.68052 C 20.2426 8.2921 20.3079 8.61779 20.3058 9.42263 C 20.3044 9.98326 20.2839 10.2266 20.2189 10.4543 C 19.7975 11.9305 18.7141 13.0045 17.1811 13.4659 L 16.759 13.5929 L 13.8608 13.6078 L 10.9626 13.6226 L 10.9626 14.3113 L 10.9626 15 L 13.8371 14.9815 C 16.599 14.9638 16.7301 14.9591 17.1821 14.861 C 18.9341 14.4809 20.347 13.4177 21.1463 11.878 C 21.5577 11.0853 21.7166 10.4039 21.7187 9.42263 C 21.7205 8.60857 21.6484 8.19948 21.3747 7.46997 C 20.7984 5.93355 19.4023 4.638 17.7763 4.13069 C 16.9205 3.86369 17.3929 3.88079 10.1225 3.85365 L 3.43862 3.82866 L 4.92915 2.38486 L 6.41968 0.941025 L 5.93577 0.470535 C 5.66966 0.211746 5.44079 0 5.42721 0 C 5.41363 0 4.34867 1.0214 3.06065 2.26973 Z",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackPurple);
export default __webpack_public_path__ + "static/media/back_purple.d579f1728ba70e89d0e2a99c6cc0210b.svg";
export { ForwardRef as ReactComponent };